module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p11"
  }, [_c('img', {
    attrs: {
      "alt": "img4.jpg",
      "height": "280",
      "src": "images/img4.jpg",
      "width": "420"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t13"
  }, [_vm._v("Photo by David Schmidt")])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("to Dunkyn and Dolan")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("thank you for sharing your lives with me")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("and making mine so much better")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1afeef34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006.vue
// module id = 69
// module chunks = 0